export default __webpack_public_path__ + "static/media/land-2.629ab573.webp";